import { render, staticRenderFns } from "./Ambission.vue?vue&type=template&id=477a0b62&scoped=true&"
import script from "./Ambission.vue?vue&type=script&lang=js&"
export * from "./Ambission.vue?vue&type=script&lang=js&"
import style0 from "./Ambission.vue?vue&type=style&index=0&id=477a0b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a0b62",
  null
  
)

export default component.exports